"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  headline: {
    margin: theme.spacing(0, 0, 2)
  },
  item: {
    display: "flex",
    "& svg": {
      margin: theme.spacing(0, 1, 0, 0)
    }
  }
}));
const List = props => {
  const {
    title,
    textcontent
  } = props.data;
  const {
    items
  } = textcontent;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h2",
    color: "secondary",
    className: css.headline,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "div"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1
  }, items.map((item, counter) => /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    className: css.item,
    key: counter,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_Check.default, {
    color: "secondary"
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: item.text
    }
  }))))));
};
var _default = exports.default = List;